import { useMemo } from "react"
import { calculateFiltersDates } from "../filters"
import { TimesheetStoreState } from "../../store/timesheetStore"
import { useSelector } from "react-redux"
import { useShouldSkipFilteredQuery } from "./useShouldSkipFilteredQuery"
import { useGetTimesheetsTotalsQuery as useGetTimesheetsTotalsQueryApi } from "../../store/api/timesheet/timesheetApi"

export const useGetTimesheetsTotalsQuery = () => {
	const timesheetDetails = useSelector((state: TimesheetStoreState) => state.timesheetDetails)
  const timesheetsTotalsQueryParams = useMemo(
		() => ({
			startDate: timesheetDetails?.filters?.startDate || String(calculateFiltersDates('StartDate')),
			endDate: timesheetDetails?.filters?.endDate || String(calculateFiltersDates('EndDate')),
			driverId: timesheetDetails?.filters?.driverId || undefined,
			branchId: timesheetDetails?.filters?.branchId || undefined,		
		}),
		[
			timesheetDetails?.filters?.startDate,
			timesheetDetails?.filters?.endDate,
			timesheetDetails?.filters?.driverId,
			timesheetDetails?.filters?.branchId
		],
	)
    const shouldSkipFilteredQuery = useShouldSkipFilteredQuery()
    const { data, isLoading, isError, isFetching, refetch } = useGetTimesheetsTotalsQueryApi(timesheetsTotalsQueryParams, {
		skip: shouldSkipFilteredQuery,
	})
    return { data, isLoading, isError, isFetching, refetch }
}